<article
  class="community-card"
  [style.background]="palette.bg"
  [style.borderColor]="palette.border"
>
  <p class="community-card__kicker">Recommended community</p>

  <div class="community-card__header">
    <span class="community-card__dot" [style.background]="palette.primary"></span>
    <div>
      <h4 [style.color]="palette.text">{{ community.communityName }}</h4>
      <p>{{ community.memberCount | number }} members</p>
    </div>
  </div>

  <p class="community-card__reason">{{ community.description }}</p>

  @if (!isJoined()) {
    <button
      type="button"
      class="join-btn"
      (click)="join.emit()"
      [style.background]="palette.primary"
      [style.borderColor]="palette.primary"
    >
      Join {{ community.communityName }}
    </button>
  }

  @if (filteredStarterPosts.length) {
    <div class="starter-posts">
      <p class="starter-posts__label">Good ways to start</p>
      @for (item of filteredStarterPosts; track item) {
        <p>{{ item }}</p>
      }
    </div>
  }
</article>
